import { ReactNode, useEffect, useState } from "react";
import { Address } from "viem";
import { useCurrencyPrice } from "~/core/hooks/useCurrencyPrice";
import { formatBalance } from "~/core/utils/formatBalance";

export const CurrencyPriceSlot = ({ 
  children, 
  currency,
}: { 
  children: ({ price, isLoading, formatBalanceWithPrice }: { price: number, isLoading: boolean, formatBalanceWithPrice: (...args: Parameters<typeof formatBalance>) => string }) => ReactNode,
  currency: Address
}) => {
  const { data, isLoading } = useCurrencyPrice(currency)

  const formatBalanceWithPrice = (...args: Parameters<typeof formatBalance>) => {
    const [balance, decimals, roundingMode] = args
    let result = formatBalance(balance * BigInt(data), decimals, roundingMode, true)
    if (result.includes('-')) {
      result = result.replace('-', '-$')
    } else {
      result = `$${result}`
    }
    return result
  }

  return children({ price: data, isLoading, formatBalanceWithPrice })
};
